import {Action, Module} from 'vuex-module-decorators';
import store from '@/store';
import {TopicModel} from '@/models/topic.model';
import {ChallengeForumApi} from '@/api/challenge-forum.api';
import {take} from 'rxjs/operators';
import {EntityStateAdapter} from '@/store/base.store';
import {PaginatedParams} from '@/api/base.api';
import {UserModel} from '@/models/user.model';

export const featureKey = 'forum';

// @ts-ignore
if (store.state.forum) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class ForumTopicsStore extends EntityStateAdapter<TopicModel> {

  @Action({commit: 'insertOne', rawError: true})
  topicCreated(topic: TopicModel) {
    return topic
  }

  @Action({commit: 'upsertOne', rawError: true})
  upsertTopic(topic: TopicModel) {
    return topic
  }

  @Action({commit: 'insertMany', rawError: true})
  async fetchAll(data: {
    challengeId: number,
    page?: number,
  }): Promise<TopicModel[]> {
    this.updateLoading(true);
    const params: PaginatedParams = {
      page: data.page,
    };
    const response = await (new ChallengeForumApi(data.challengeId))
      .allPaginated(params)
      .pipe(take(1))
      .toPromise();

    this.context.commit('updateAllPageParams', response);
    return response.data
  }

  @Action({commit: 'removeOne', rawError: true})
  async destroyTopic(data: { challengeId: number, topicId: number }): Promise<number> {
    await (new ChallengeForumApi(data.challengeId))
      .destroy(data.topicId)
      .pipe(take(1))
      .toPromise();
    return data.topicId;
  }

  get topics(): TopicModel[] {
    return this._entities;
  }

  get currentPage(): number {
    return super.currentPage;
  }

  get lastPage(): number {
    return super.lastPage;
  }

  get total(): number {
    return super.total;
  }

  get perPage(): number {
    return super.perPage;
  }

  get loading(): boolean {
    return super.loading;
  }

  get isAuthor(): (topic: TopicModel, user: UserModel) => boolean {
    return (topic: TopicModel, user: UserModel) => (user?.id === topic.user?.id)
  }
}
